export enum StockManagementType {
  ARTICLES = 'articles',
  OPTION_ARTICLES = 'options',
  ALL = 'all',
}
